import { useQuery } from '@tanstack/react-query'
import { getCurrentUser } from '../services/api.js'
import { useAuthStore } from '../stores/authStore.js'

/** Utilisateur connecté : version serveur (droits à jour) si chargée, sinon celle du store. */
export function useCurrentUser() {
  const authUser = useAuthStore((state) => state.user)
  const { data: me, isLoading } = useQuery({
    queryKey: ['currentUser'],
    queryFn: getCurrentUser,
    staleTime: 60000,
  })
  return { user: me ?? authUser, isLoading: isLoading && !authUser }
}
